import React from 'react'
import { Route, BrowserRouter as Router, Routes, Outlet, Navigate } from 'react-router-dom'
import CookieModal from './components/CookiePopup/CookiePopup'
import Footer from './components/Footer'
import Header from './components/Header'

const MainPage = React.lazy(() => import('./components/Page2026'))
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy'))
const TermsOfService = React.lazy(() => import('./components/TermsOfService'))

function MainLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      {/* Без pt: иначе под fixed-хедером видна полоса фона body; отступ под хедер — на страницах */}
      <main className="flex w-full flex-1 flex-col">
        <Outlet />
      </main>
      <Footer />
      <CookieModal />
    </div>
  )
}

function App() {
  return (
    <Router>
      <React.Suspense fallback={<div />}>
        <Routes>
          <Route path="/2026" element={<Navigate to="/" replace />} />
          <Route element={<MainLayout />}>
            <Route path="/" element={<MainPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Route>
        </Routes>
      </React.Suspense>
    </Router>
  )
}

export default App
